<template>
  <div class="grid-header">
    <div class="nav-home primary item-title">
      <div>MARINE</div>
      <div>SPATIAL</div>
      <div>PLANNING</div>
      <div>
        <span class="version-label">v.{{ version }}</span>
      </div>
    </div>
    <div class="nav-item top-menu-item">
      <vs-navbar
        v-model="activeMenus.top"
        color="#FCFCFD"
        text-color="#01212B"
        active-text-color="#00a09e"
        type="border"
        class="nabarx"
      >
        <vs-navbar-item index="0" class="nav-subitem">
          <a href="#">{{ data.global.name }}</a>
        </vs-navbar-item>
        <vs-navbar-item index="1" class="nav-subitem">
          <a href="#">{{ data.national.name }}</a>
        </vs-navbar-item>
        <vs-navbar-item index="2" class="nav-subitem">
          <a href="#">{{ data.regional.name }}</a>
        </vs-navbar-item>
        <vs-navbar-item index="3" class="nav-subitem">
          <a href="#">{{ data.local.name }}</a>
        </vs-navbar-item>
        <!-- <vs-spacer /> -->
        <div class="menu-separator">
          <i class="material-icons menu-ico">more_vert</i>
        </div>
        <!-- <vs-tooltip text="Go Home" position="left"> -->
        <!-- <vs-button
          color="#333"
          type="flat"
          icon="home"
          size="large"
          class="menu-ico"
          title="Starting Project"
          @click="setProjectTemplate()"
        /> -->
        <!-- </vs-tooltip> -->
        <!-- <vs-tooltip text="Science" position="left"> -->
        <vs-button
          color="#333"
          type="flat"
          icon="library_books"
          size="large"
          class="menu-ico"
          title="Science in MSP"
          @click="toggleScience(true)"
        />
        <!-- </vs-tooltip> -->
        <!-- <vs-tooltip text="About MSP" position="left"> -->
        <vs-button
          color="#333"
          type="flat"
          icon="video_library"
          size="large"
          class="menu-ico"
          title="Medaqua Webinar"
          @click="$router.push('webinar')"
        />
        <vs-button
          color="#333"
          type="flat"
          icon="help_outline"
          size="large"
          class="menu-ico"
          title="About..."
          @click="toggleAbout(true)"
        />
        <!-- </vs-tooltip> -->
      </vs-navbar>
    </div>
    <!-- Regional Scale bar -->
    <div v-if="isRegionalScale" class="nav-item regional-menu-item">
      <vs-navbar
        v-model="activeMenus.regional"
        color="#FCFCFD"
        text-color="#01212B"
        active-text-color="#00a09e"
        type="border"
        class="nabarx"
      >
        <vs-navbar-item
          v-for="(region, index) in data.regional.regions"
          :key="index"
          :index="index"
          class="nav-subitem"
        >
          <a href="#">{{ region.alias }}</a>
        </vs-navbar-item>
      </vs-navbar>
    </div>
    <!---->
    <div class="nav-item mid-menu-item">
      <vs-navbar
        v-model="activeMenus.mid"
        color="#FCFCFD"
        text-color="#01212B"
        active-text-color="#00a09e"
        type="border"
        class="nabarx"
      >
        <vs-navbar-item
          v-for="(sector, index) in activeSectors"
          :key="index"
          :index="index"
          class="nav-subitem"
        >
          <div v-if="sector.hasOwnProperty('url')" class="sector-nav">
            <i class="material-icons">link</i>
            <!-- <vs-tooltip
              v-if="sector.hasOwnProperty('description')"
              :text="sector.description"
              title="External app"
              position="bottom"
            > -->
            <a :href="sector.url" :title="sector.description" target="blank">{{
              sector.alias
            }}</a>
            <!-- </vs-tooltip> -->
          </div>
          <div v-else class="sector-nav">
            <a
              v-if="sector.hasOwnProperty('url')"
              :href="sector.url"
              target="blank"
              >{{ sector.alias }}</a
            >
            <img
              v-else-if="sector.name === 'Energy'"
              :src="
                activeSector.name === sector.name
                  ? require(`@/assets/menus/marine_filled.png`)
                  : require(`@/assets/menus/marine.png`)
              "
              class="sector-ico"
            />
            <img
              v-else
              :src="
                activeSector.name === sector.name
                  ? require(`@/assets/menus/aquaculture_filled.png`)
                  : require(`@/assets/menus/aquaculture.png`)
              "
              class="sector-ico"
            />
            <a href="#">{{ sector.alias }}</a>
          </div>
        </vs-navbar-item>
        <vs-spacer />
      </vs-navbar>
    </div>
    <div class="nav-item bottom-menu-item">
      <vs-navbar
        v-model="activeMenus.bottom"
        color="#FCFCFD"
        text-color="#01212B"
        type="border"
        class="nabarx"
      >
        <vs-navbar-item
          v-for="(type, index) in activeTypes"
          :key="index"
          :index="index"
          class="nav-subitem nav-categories"
        >
          <div
            :class="{ 'active-layer-group': isActive(type) }"
            class="layers-panel"
          >
            <a class="layer-category-name">{{ type.alias }}</a>
            <div class="layers-nav" :style="{width:panelWidth}">
              <div
                :class="{ 'active-layer-group': isActive(type) }"
                class="layers-nav-header"
              >
                <div class="layer-category-icon">
                  <img
                    :src="
                      isActive(type)
                        ? require(`@/assets/menus/${type.ico}_filled.png`)
                        : require(`@/assets/menus/${type.ico}.png`)
                    "
                    class="type-ico"
                  />
                </div>
                <span class="layer-category-name">{{ type.alias }}</span>
              </div>
              <layer-switcher
                :metadata="{ provider: type.provider, groupName: type.name }"
                :layers="type.layers"
                :class="{ cursive: areSpeciesLayerNames(type) }"
                @resetOnLayerChange="resetLayerSwitches"
              />
            </div>
          </div>
        </vs-navbar-item>
        <!-- <vs-spacer /> -->
      </vs-navbar>
    </div>
  </div>
</template>
<script>
import global from "@/data/global";
import national from "@/data/national";
import local from "@/data/local";
import regional from "@/data/regional";
import LayerSwitcher from "@/components/LayerSwitcher";
import { mapState, mapActions } from "vuex";
import { MENUS_INDEX } from "@/constants.js";

export default {
  components: {
    "layer-switcher": LayerSwitcher
  },
  data() {
    return {
      activeSectors: [],
      activeTypes: [],
      data: {
        global: {},
        national: {},
        local: {},
        regional: {}
      },
      isHover: false,
      version: process.env.VERSION,
      panelWidth: "100%",
    };
  },
  computed: {
    ...mapState({
      activeMenus: state => state.activeMenus
    }),
    ...mapState("map", {
      activeLayerGroup: state => state.activeLayerGroup
    }),
    activeScale() {
      switch (parseInt(this.activeMenus.top)) {
        case 0:
          return this.data.global;
        case 1:
          return this.data.national;
        case 2:
          return this.data.regional.regions[this.activeMenus.regional];
        case 3:
          return this.data.local;
        default:
          return this.data.global;
      }
    },
    activeRegion() {
      return this.data.regional.regions
        ? this.data.regional.regions[this.activeMenus.regional]
        : 0;
    },
    isRegionalScale() {
      return parseInt(this.activeMenus.top) === 2;
    },
    activeSector() {
      return this.activeSectors.length > 0
        ? this.activeSectors[this.activeMenus.mid]
        : 0;
    }
  },
  watch: {
    activeScale(newScale, oldScale) {
      /* On scale change, select new sectors and do some cleaning */
      if (newScale !== oldScale) {
        this.activeSectors = newScale.sectors;
        this.resetSectorMenu();
        this.resetLayerSwitches();
        this.resetLayerGroup();
        this.cleanMap();
      }
    },
    activeRegion(newRegion, oldRegion) {
      if (newRegion !== oldRegion && this.isRegionalScale) {
        this.activeSectors = newRegion.sectors;
      }
    },
    activeSector() {
      this.activeTypes = this.activeSector.types;
      this.changeActiveData({
        scale: this.activeScale,
        sector: this.activeSector,
      });
    },
    activeTypes(newval) {
      this.panelWidth = newval.length == 1 ? "20%" : "100%";
    },
  },
  created() {
    /* Initialize data structure */
    this.data.global = global;
    this.data.national = national;
    this.data.local = local;
    this.data.regional = regional;

    /* Default values */
    this.changeActiveData({
      scale: this.activeScale,
      sector: this.activeSector
    });
  },
  methods: {
    ...mapActions({
      toggleAbout: "toggleAbout",
      toggleHome: "toggleHome",
      toggleScience: "toggleScience",
      resetSectorMenu: "resetSectorMenu",
      setActiveMenus: "setActiveMenus"
    }),
    ...mapActions("map", {
      cleanMap: "cleanMap",
      changeActiveData: "changeActiveData",
      resetLayerGroup: "resetLayerGroup"
    }),
    setProjectTemplate() {
      this.setActiveMenus({
        top: MENUS_INDEX.SCALES.GLOBAL,
        mid: MENUS_INDEX.SECTORS.GLOBAL_AQUACULTURE,
        bottom: -1
      });
    },
    isActive(type) {
      return type.name === this.activeLayerGroup;
    },
    areSpeciesLayerNames(type) {
      return (
        type.name === "BiologicalSuitability" ||
        type.name === "FishFarmingOpportunities" ||
        type.name === "FarmingOpportunities" ||
        type.name === "AquacultureWindWavesOpportunities" ||
        type.name === "AquacultureWavesOpportunities" ||
        type.name === "AquacultureWindOpportunities"
      );
    },
    resetLayerSwitches() {
      /// todo: desacoplar la visibilidad de la capa del fichero de constantes
      /* Disable layers in all scales. */
      this.disableLayerSwitchControls(this.data.global.sectors);
      this.disableLayerSwitchControls(this.data.national.sectors);
      this.disableLayerSwitchControls(this.data.local.sectors);
      for (const region of this.data.regional.regions) {
        this.disableLayerSwitchControls(region.sectors);
      }
    },
    disableLayerSwitchControls(sectors) {
      sectors.map(sector =>
        sector.types.map(type =>
          type.layers.filter(lyr => {
            lyr.visible = false;
          })
        )
      );
    }
  }
};
</script>
<style scoped>
.grid-header {
  display: grid;
  grid-template-columns: 12rem auto 12rem;
  grid-template-rows: repeat(3, 1fr);
  height: 100%;
}
.nav-home {
  grid-column: 1 / 2;
  grid-row: 1 / 5;

  display: flex;
}
.nav-item {
  display: flex;
  align-items: left;
  justify-content: left;
  min-height: 50px;
}

.vs-navbar >>> .vs-con-items {
  flex: 1;
  align-items: flex-end;
}

.nav-subitem {
  flex: 1;
  display: flex;
  justify-content: center;
}
.nav-subitem:hover {
  cursor: pointer;
  background-color: whitesmoke;
  color: #01212b !important;
}

.item-title {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.top-menu-item {
  grid-column: 2 / 6;
}
.top-menu-item .vs-navbar--item a {
  font-size: 1.2rem;
}

.mid-menu-item {
  grid-column: 2 / 6;
}

.mid-menu-item .vs-navbar--item a {
  font-size: 1rem;
}

.regional-menu-item {
  grid-column: 2 / 6;
}

.regional-menu-item .vs-navbar--item a {
  font-size: 1.1rem;
}

.bottom-menu-item {
  grid-column: 2/6;
}

.bottom-menu-item .vs-navbar--item a {
  font-size: 0.8rem;
}

.is-active-item {
  color: #00a09e;
}

.mid-menu-item .is-active-item .vs-navbar-after {
  width: 50%;
}

.sector-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-top: 2px;
}

.bottom-menu-item .is-active-item {
  color: #01212b !important;
}

.menu-ico {
  margin-right: 1rem;
  color: #00a09e;
}

.menu-ico >>> i {
  font-size: 1.5rem;
  color: #00a09e;
}

.menu-separator {
  margin-bottom: 4px;
}

/* Layers Panel */

.layer-category-name {
  font-size: 0.8rem;
  text-overflow: ellipsis;
  position: relative;
  overflow: hidden;
}

.layer-category-icon {
  padding: 5px;
}

.layers-nav {
  overflow: hidden;
  max-height: 1000px;
  display: inline-block;
  flex-direction: column;
  position: absolute;
  left: 0px;
  top: -5px;
  z-index: 2000;
  box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.15);
  background: white;
  transition: all 0.25s ease;
}

.layers-nav-header {
  display: block;
  font-size: 1rem;
  position: relative;
  z-index: 2;
  border-bottom: 4px solid #00a09e;
  text-align: center;
  padding: 5px;
}

.layers-nav-header .layer-category-name {
  font-size: 0.9rem;
}

.nav-categories .layers-nav {
  visibility: hidden;
}
.nav-categories:hover .layers-nav {
  visibility: visible;
}

.layers-list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 55vh;
  padding: 10px;
}

.layers-panel {
  float: left;
  border-bottom: 5px solid #00a09e;
}

.active-layer-group {
  border-bottom: 5px solid #19535f !important;
}

.layer-switcher {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  padding: 5px;
}

.vs-navbar {
  z-index: 9000;
  align-items: flex-end;
  padding-left: 1rem;
  padding-right: 1rem;
}

.vs-navbar .vs-navbar--item.is-active-item >>> .vs-navbar-after {
  width: 90%;
}

.version-label {
  font-size: 0.7rem;
}

.sector-ico {
  width: 35px;
  height: 35px;
}

.type-ico {
  max-height: 50px;
}
.cursive {
  font-style: italic;
}
</style>
